import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-awesome-modal';

import PageHeader from '../../../shared/page-header/components/page-header';
import CloseBtn from '../../../shared/close-btn/components/close-btn';
import PaymentMethodsHelpers from '../helpers/payment-methods-helpers';
import { togglePaymentMethodDetailsModal } from '../actions/payment-method-actions';

import '../styles/payment-method-details-modal.css';

class PaymentMethodDetailsModal extends Component {
  closeModal() {
    const { togglePaymentMethodDetailsModal } = this.props;

    togglePaymentMethodDetailsModal(false, null);
  }

  renderData(data) {
    if (data) {
      return Object.keys(data).map(function(key, index) {
        return (
          <div className="row payment-method-details-modal__content" key={index}>
            <div className="col-md-6 key">{PaymentMethodsHelpers.formatKey(key)}</div>
            <div className="col-md-6 value">{data[key]}</div>
          </div>
        );
      });
    }
  }

  render() {
    const { showPaymentMethodDetailsModal, selectedPaymentMethod } = this.props;
    const data = selectedPaymentMethod && selectedPaymentMethod.fields_data;

    return (
      <Modal visible={showPaymentMethodDetailsModal} effect="fadeInUp" onClickAway={() => this.closeModal()}>
        <div className="default-modal payment-method-details-modal">
          <CloseBtn callback={this.closeModal.bind(this)} />
          <div className="text-center">
            <PageHeader title={'PAYMENT_METHOD.DETAILS_TITLE'} />
          </div>
          {this.renderData(data)}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  showPaymentMethodDetailsModal: state.paymentMethodsReducer.showPaymentMethodDetailsModal,
  selectedPaymentMethod: state.paymentMethodsReducer.selectedPaymentMethod,
});

const mapDispatchToProps = dispatch => ({
  togglePaymentMethodDetailsModal: (show, paymentMethod) => {
    dispatch(togglePaymentMethodDetailsModal(show, paymentMethod));
  },
});

PaymentMethodDetailsModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethodDetailsModal);



// WEBPACK FOOTER //
// ./src/app/main/payment-methods/components/payment-method-details-modal.js